import React, { useState } from 'react'

import { useParams } from 'react-router'
import { Button } from 'src/components/__legacy__/button/button'
import { useMember } from 'src/legacy_modules/entities/member/atom'

import { DisableModal } from './disable-modal'
import { trialIdParamName } from '../../trial-detail'

type Props = {
  memberUid: string
}

export const MemberDisableButton: React.FC<Props> = props => {
  const { memberUid } = props
  const [modalOpen, setModalOpen] = useState(false)

  const user = useMember(memberUid)

  const { trialUid = '' } = useParams<{ [trialIdParamName]: string }>()

  return (
    <>
      <Button
        text="無効化"
        size="S"
        buttonType="normal"
        onClick={() => setModalOpen(true)}
      />
      {modalOpen && !!user && (
        <DisableModal
          userName={`${user.lastName} ${user.firstName}`}
          closeModal={() => setModalOpen(false)}
          trialUid={trialUid}
          memberUid={memberUid}
        />
      )}
    </>
  )
}
